import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import Swal from "sweetalert2";
import { FaEye } from "react-icons/fa";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import EmpDetailsCommonEdit from "./EmpDetailsCommonEdit";
import { store } from "../../../App";
import { ExportToExcelButton, generatePDF, GetDetails, LabelHeader, ModuleHeaderTitle } from "../../utils/commonFunctions";
// import   {CanvasJSReact, CanvasJSChart }from 'canvasjs-react-charts';

const MonthlyPaybillConfirmation = () => {
  const [EmpTypeList, setEmpTypeList] = useState();
  const [monthlist, setmonthlist] = useState();
  const [yearlist, setyearlist] = useState();

  const [show, setShow] = useState(false);

  const [MonthlyPaybill, setMonthlyPaybill] = useState([]);
  const [afterConfirm, setAfterConfirm] = useState([]);
  const [beforeConfirm, setBeforeConfirm] = useState([]);

  const [monthData, setMonthData] = useState([]);
  const [yearName, setyearName] = useState([]);
  const [monthname, setmonthname] = useState([]);
  const [displayemptype, setDisplayEmptype] = useState();
  const [emptypename, setEmpNameType] = useState();
  const [displayPaymentType, setdisplayPaymentType] = useState();
  const [EmpId, setEmpId] = useState();
  const [EmpType, setEmpType] = useState();
  const [payType, setpayType] = useState();
  const [confirmMonth, setConfirmMonth] = useState();
  const [Year, setYear] = useState();
  const [showcomp, setShowcomp] = useState(false);

  // confirm
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [checkBoxAll, setcheckAll] = useState(false);

  // Generate
  const [selectedCheckboxGen, setSelectedCheckboxGen] = useState([]);
  const [selectedListGen, setSelectedListGen] = useState([]);
  const [checkBoxAllGen, setcheckAllGen] = useState(false);

  // view
  const [selectedCheckboxview, setSelectedCheckboxview] = useState([]);
  const [selectedListview, setSelectedListview] = useState([]);
  const [checkBoxAllview, setcheckAllview] = useState(false);



  let history = useHistory();

  const formik = useFormik({
    initialValues: { emp_type: "", year: "", confirm_month: "", payment_type: "" },
    validate: (values) => { const errors = {}; if (!values.emp_type) { errors.emp_type = "From Date is required"; } if (!values.year) { errors.year = "From Date is required"; } if (!values.confirm_month) { errors.confirm_month = "From Date is required"; } if (!values.payment_type) { errors.payment_type = "From Date is required"; } return errors; },
    onSubmit: async (values) => {
      let yearValue = formik.values.year;
      setyearName(yearValue);
      let monthvalue = monthData
        .filter((item) => item.month_id === formik.values.confirm_month)
        .map((item) => item.month_name);
      setmonthname(monthvalue);
      let empValue = emptypename
        .filter((item) => item.emptype_id == formik.values.emp_type)
        .map((item) => item.emptype_name);
      setDisplayEmptype(empValue);
      if (formik.values.payment_type == "reg") {
        setdisplayPaymentType("REGULAR");
      } else {
        setdisplayPaymentType("SUPPLEMENTRY");
      }
      store.dispatch({ type: "SHOW_SPINNER" });
      await new Promise((resolve) => setTimeout(resolve, 500));
      HousingService.GetMonthlyPayBillDetails_BeforeConfirm(values).then(
        (response) => {
          if (response.data) {
            setBeforeConfirm(response.data);
            setShow(true);
            setShowcomp(false);
          }
        }
      );
      await new Promise((resolve) => setTimeout(resolve, 1000));
      HousingService.GetMonthlyPayBillDetails_Generated(values).then(
        (response) => {
          if (response.data) {
            setMonthlyPaybill(response.data);
            setShow(true);
            setShowcomp(false);
          }
        }
      );
      await new Promise((resolve) => setTimeout(resolve, 2000));
      HousingService.GetMonthlyPayBillDetails_AfterConfirm(values).then(
        (response) => {
          if (response.data) {
            setAfterConfirm(response.data);
            setShow(true);

            setShowcomp(false);

            store.dispatch({ type: "HIDE_SPINNER" });
          }
        }
      );
    }
  });
  React.useEffect(() => {
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) { setEmpNameType(res.data); let options = res.data.map((item, i) => { return (<option key={i} value={item.emptype_id}> {item.emptype_name} </option>); }); setEmpTypeList(options); }
    });

    HousingService.fetchMonthList().then((res) => {
      if (res.data) { setMonthData(res.data); let options = res.data.map((item, i) => { return (<option key={i} value={item.month_id}> {item.month_name} </option>); }); setmonthlist(options); }
    });

    HousingService.fetchYearList().then((res) => {
      if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.year}> {item.year} </option>); }); setyearlist(options); }
    });
  }, []);



  const showNotification = (type, message) => { if (type === "success") { Swal.fire("Success", message, "success"); } else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); } };

  const handleConfirm = (emp_type, paymentType, confirmMonth, year) => {
    if (selectedList.length > 0) {
      const updatedList = selectedList.map((item) => {
        return { ...item, payment_type: paymentType, confirm_month: confirmMonth, year: year };
      });

      const finalRequestBody = { emp_type: emp_type, generateConfirmlist: updatedList };
      // console.log("finalRequestBody:", finalRequestBody)

      Swal.fire({
        text: "Do You Want to Confirm?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const Confrim = await HousingService.confirm_UpdatList(finalRequestBody);
          if (Confrim?.data?.SCODE === "01") {
            let values = { emp_type: emp_type, year: year, confirm_month: confirmMonth, payment_type: paymentType };
            HousingService.GetMonthlyPayBillDetails_AfterConfirm(values).then(
              (response) => {
                setAfterConfirm(response.data);
                setShow(true);
                setShowcomp(false);
              }
            );
            HousingService.GetMonthlyPayBillDetails_BeforeConfirm(values).then(
              (response) => {
                setBeforeConfirm(response.data);
                setShow(true);
                setShowcomp(false);
              }
            );
            setSelectedCheckbox([]);
            setSelectedList([]);
            showNotification("success", "Confirmed successfully");
            setcheckAll(false);
          }
        }
      });
    } else {
      showNotification("warning", "Please Select CheckBox ");
    }
  };

  const GeneratedPaybill = (emp_type, paymentType, confirmMonth, year) => {
    if (selectedListGen.length > 0) {
      const updatedList = selectedListGen.map((item) => {
        return { ...item, emp_type: emp_type, payment_type: paymentType, confirm_month: confirmMonth, year: year };
      });
      const finalRequestBody = { genertedPaybillList: updatedList };
      console.log("finalRequestBody:", finalRequestBody)
      Swal.fire({
        text: "Do You Want to Generate Paybill?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(async (result) => {
        if (result.isConfirmed) {
          const Confrim = await HousingService.paybillconfirm_UpdatList(finalRequestBody);
          if (Confrim?.data?.SCODE === "01") {

            let values = { emp_type: emp_type, year: year, confirm_month: confirmMonth, payment_type: paymentType };
            HousingService.GetMonthlyPayBillDetails_Generated(values).then(
              (response) => { setMonthlyPaybill(response.data); setShow(true); setShowcomp(false); }
            );

            HousingService.GetMonthlyPayBillDetails_AfterConfirm(values).then(
              (response) => { setAfterConfirm(response.data); setShow(true); setShowcomp(false); }
            );

            setSelectedCheckboxGen([]);
            setSelectedListGen([]);
            showNotification("success", "Paybill Generated successfully");
            setcheckAllGen(false);
          }
        }
      });
    } else {
      showNotification("warning", "Please Select CheckBox ");
    }
  };

  const handlePdf = (emp_id, payment_type, year, confirm_month) => {
    const values = { emp_id: emp_id, payment_type: payment_type, year: year, confirm_month: confirm_month };
    HousingService.emp_pay_particulars_pdf(values).then((res) => { const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); let tab = window.open(); tab.location.href = url; });
  };







  const SaveParams = (emp_id, emp_type, payment_type, confirm_month, year) => {
    setShow(false); setShowcomp(true); setEmpId(emp_id); setEmpType(emp_type); setpayType(payment_type); setConfirmMonth(confirm_month); setYear(year);
  };

  const Viewpayslipsofselected = (paymentType, confirmMonth, year) => {
    if (selectedListview.length > 0) {
      store.dispatch({ type: "SHOW_SPINNER" });
      const updatedListview = selectedListview.map((item) => { return { emp_id: item.emp_id, payment_type: paymentType, confirm_month: confirmMonth, year: year }; });
      // console.log("updatedListview:",updatedListview);
      HousingService.generatePayslipForEmployees(updatedListview).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        let tab1 = window.open(); tab1.location.href = url;
        setSelectedCheckboxview([]);
        setSelectedListview([]);
        setcheckAllview(false);
        store.dispatch({ type: "HIDE_SPINNER" });
      }).catch((error) => { console.error("Error generating payslip:", error); store.dispatch({ type: "HIDE_SPINNER" }); });
    } else {
      showNotification("warning", "Please Select CheckBox ");
    }
  };

  // const checkAllAction = (e) => {
  //   const select = e.target.checked;
  //   setcheckAll(select);
  //   if (select) {
  //     const checkBoxValues = beforeConfirm.map((item) => item.emp_id);
  //     const checkedList = beforeConfirm.map((item) => {
  //       if (checkBoxValues.includes(item.emp_id)) {
  //         return { ...item, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year };
  //       }
  //     }); setSelectedCheckbox(checkBoxValues); setSelectedList(checkedList);
  //   } else {
  //     setSelectedCheckbox([]); setSelectedList([]);
  //   }
  // };




  // const handleCheckBox = (e, item) => {
  //   const select = e.target.checked; setSelectedCheckbox((prevState) => { if (select) { return [...prevState, item]; } else { return prevState.filter((value) => value !== item); } });
  //   setSelectedList((prevLis) => { if (select) { const selectedItem = beforeConfirm.find((object) => object.emp_id === item); return [...prevLis, selectedItem]; } else { return prevLis.filter((value) => value.emp_id !== item); } });
  //   if (select && selectedCheckbox.length === beforeConfirm.length - 1) { setcheckAll(true); } else { setcheckAll(false); }
  // };


  // const checkAllActiongenerate = (e) => {
  //   const select = e.target.checked; setcheckgenereateAll(select); if (select) {
  //     const checkBoxValues = afterConfirm.map((item) => item.emp_id);
  //     const checkedList = afterConfirm.map((item) => {
  //       if (checkBoxValues.includes(item.emp_id)) {
  //         return { ...item, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year };
  //       }
  //     }); setSelectedCheckbox(checkBoxValues); setSelectedList(checkedList);
  //   } else { setSelectedCheckbox([]); setSelectedList([]); }
  // };

  const handleCheckBox = (e, emp_id) => {
    const checked = e.target.checked;
    setSelectedCheckbox((prevSelected) => {
      if (checked) {
        const updated = [...new Set([...prevSelected, emp_id])];
        if (updated.length === beforeConfirm.length) setcheckAll(true);
        return updated;
      } else {
        const updated = prevSelected.filter((id) => id !== emp_id);
        setcheckAll(false);
        return updated;
      }
    });
    setSelectedList((prevList) => {
      if (checked) {
        const selectedItem = beforeConfirm.find((obj) => obj.emp_id === emp_id);
        if (!selectedItem) return prevList;
        const newItem = { ...selectedItem, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year, };
        const updatedList = [...prevList.filter((v) => v.emp_id !== emp_id), newItem];
        return updatedList;
      } else {
        return prevList.filter((v) => v.emp_id !== emp_id);
      }
    });
  };

  const handleCheckBoxgenerate = (e, emp_id) => {
    const checked = e.target.checked;

    setSelectedCheckboxGen((prevSelected) => {
      let updated;
      if (checked) {
        updated = [...new Set([...prevSelected, emp_id])];
      } else {
        updated = prevSelected.filter((id) => id !== emp_id);
      }

      setcheckAllGen(updated.length === afterConfirm.length);
      return updated;
    });

    setSelectedListGen((prevList) => {
      if (checked) {
        const selectedItem = afterConfirm.find((obj) => obj.emp_id === emp_id);
        if (!selectedItem) return prevList;
        const newItem = {
          ...selectedItem,
          payment_type: formik.values.payment_type,
          confirm_month: formik.values.confirm_month,
          year: formik.values.year,
        };
        return [...prevList.filter((v) => v.emp_id !== emp_id), newItem];
      } else {
        return prevList.filter((v) => v.emp_id !== emp_id);
      }
    });
  };

  const handleCheckBoxviewapaybill = (e, emp_id) => {
    const checked = e.target.checked;

    setSelectedCheckboxview((prevSelected) => {
      let updated;
      if (checked) {
        updated = [...new Set([...prevSelected, emp_id])];
      } else {
        updated = prevSelected.filter((id) => id !== emp_id);
      }

      setcheckAllview(updated.length === MonthlyPaybill.length);
      return updated;
    });

    setSelectedListview((prevList) => {
      if (checked) {
        const selectedItem = MonthlyPaybill.find((obj) => obj.emp_id === emp_id);
        if (!selectedItem) return prevList;
        const newItem = {
          ...selectedItem,
          payment_type: formik.values.payment_type,
          confirm_month: formik.values.confirm_month,
          year: formik.values.year,
        };
        return [...prevList.filter((v) => v.emp_id !== emp_id), newItem];
      } else {
        return prevList.filter((v) => v.emp_id !== emp_id);
      }
    });
  };

  const checkAllAction = (e) => {
    const selectall = e.target.checked;
    setcheckAll(selectall);

    if (selectall) {
      const checkBoxValues = beforeConfirm.map((item) => item.emp_id);
      const checkedList = beforeConfirm.map((item) => ({
        ...item,
        payment_type: formik.values.payment_type,
        confirm_month: formik.values.confirm_month,
        year: formik.values.year,
      }));

      setSelectedCheckbox(checkBoxValues);
      setSelectedList(checkedList);
    } else {
      setSelectedCheckbox([]);
      setSelectedList([]);
    }
  };

  const checkAllActiongenerate = (e) => {
    const selectgen = e.target.checked;
    setcheckAllGen(selectgen);

    if (selectgen) {
      const checkBoxValuesgen = afterConfirm.map((item) => item.emp_id);
      const checkedListgen = afterConfirm.map((item) => ({ ...item, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year, }));
      setSelectedCheckboxGen(checkBoxValuesgen);
      setSelectedListGen(checkedListgen);
    } else {
      setSelectedCheckboxGen([]);
      setSelectedListGen([]);
    }
  };

  const checkAllActionviewPaybill = (e) => {
    const selectview = e.target.checked;
    setcheckAllview(selectview);
    if (selectview) {
      const checkBoxValuesview = MonthlyPaybill.map((item) => item.emp_id);
      const checkedListview = MonthlyPaybill.map((item) => ({ ...item, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year, }));
      setSelectedCheckboxview(checkBoxValuesview);
      setSelectedListview(checkedListview);
    } else {
      setSelectedCheckboxview([]);
      setSelectedListview([]);
    }
  };

  // const handleCheckBoxgenerate = (e, item) => {
  //   const select = e.target.checked; setSelectedCheckbox((prevState) => { if (select) { return [...prevState, item]; } else { return prevState.filter((value) => value !== item); } });
  //   setSelectedList((prevLis) => { if (select) { const selectedItem = afterConfirm.find((object) => object.emp_id === item); return [...prevLis, selectedItem]; } else { return prevLis.filter((value) => value.emp_id !== item); } });
  //   if (select && selectedCheckbox.length === afterConfirm.length - 1) {
  //     setcheckgenereateAll(true);
  //   } else { setcheckgenereateAll(false); }
  // };




  // const handleCheckBoxviewapaybill = (e, item) => {
  //   const select = e.target.checked;

  //   setSelectedCheckbox((prevState) => { if (select) { return [...prevState, item]; } else { return prevState.filter((value) => value !== item); } });
  //   setSelectedList((prevLis) => { if (select) { const selectedItem = MonthlyPaybill.find((object) => object.emp_id === item); return [...prevLis, selectedItem]; } else { return prevLis.filter((value) => value.emp_id !== item); } });
  //   if (select && selectedCheckbox.length === MonthlyPaybill.length - 1) {
  //     setcheckviewpaybillAll(true);
  //   } else {
  //     setcheckviewpaybillAll(false);
  //   }
  // };

  // const checkAllActionviewPaybill = (e) => {
  //   const select = e.target.checked;
  //   setcheckviewpaybillAll(select);
  //   if (select) {
  //     const checkBoxValues = MonthlyPaybill.map((item) => item.emp_id);
  //     const checkedList = MonthlyPaybill.map((item) => {
  //       if (checkBoxValues.includes(item.emp_id)) { return { ...item, payment_type: formik.values.payment_type, confirm_month: formik.values.confirm_month, year: formik.values.year }; }
  //     }); setSelectedCheckbox(checkBoxValues); setSelectedList(checkedList);
  //   } else { setSelectedCheckbox([]); setSelectedList([]); }
  // };

  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <ModuleHeaderTitle title="Monthly Paybill Confirmation" />
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <button className="btn " style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="button"
              onClick={() => history.goBack()}
            > Back </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row className="p-2 ">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" ><LabelHeader title="Employee Type" /><Field component="select" name="emp_type" className={formik.touched.emp_type && formik.errors.emp_type ? "form-control is-invalid" : "form-control"} > <option value="select">Select</option> {EmpTypeList} </Field> </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <LabelHeader title="Month" /> <Field component="select" name="confirm_month" className={formik.touched.confirm_month && formik.errors.confirm_month ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {monthlist} </Field> </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <LabelHeader title="Year" /> <Field component="select" name="year" className={formik.touched.year && formik.errors.year ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {yearlist} </Field> </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Payment Type" /> <Field component="select" name="payment_type" value={formik.values.payment_type} onChange={(e) => formik.setFieldValue("payment_type", e.target.value)} className={formik.touched.payment_type && formik.errors.payment_type ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> <option value="reg">Regular</option> <option value="supp">Supplementary</option> </Field> </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>

            {showcomp && (
              <EmpDetailsCommonEdit EmpId={EmpId} EmpType={EmpType} payType={payType} confirmMonth={confirmMonth} Year={Year} />
            )}
            {show && (
              <div style={{ overflow: "auto", height: "700px", position: "sticky", top: "0px" }} >
                <div>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" >
                      <ExportToExcelButton tableId="my-table1" filename="MonthlybillConfirmationReport" sheet="tablexls" buttonText="Excel" />  <button className="btn btn-danger btn-sm"
                      onClick={() => generatePDF("my-table1", "Pay bill Generated List", "MonthlybillConfirmationReport.pdf", 8)}
                      type="button" style={{ float: "right", marginLeft: "5px" }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col> </OFMSUI.Row>

                  <OFMSUI.Table striped bordered hover id="my-table1">
                    <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                      <tr> <td colSpan={11} style={{ textAlign: "center" }}> Paybill Generated List For {displayemptype}- {displayPaymentType} for the {monthname} {yearName} </td> </tr>
                      <tr className="table_countshead"> <th className="text-center">S No. </th> <th>Employee ID</th> <th>Employee Name</th> <th>Designation</th>  <th className="text-center">Earnings(in Rs/-)</th> <th className="text-center">Deductions(in Rs/-)</th> <th className="text-center">Loan(in Rs/-)</th> <th className="text-center" >Net Salary(in Rs/-)</th> <th>View</th> <th classnaem="text-center"> Check All <input type="checkbox"
                        onChange={(e) => checkAllActionviewPaybill(e)} checked={checkBoxAllview} />
                      </th> </tr>
                    </thead>

                    <tbody> {MonthlyPaybill.map((item, index) => (<> <tr key={index}> <td>{index + 1}</td> <td>{item.emp_id}</td> <td>{item.name}</td> <td>{item.designation}</td>  <td className="text-end">{item.earnings}</td> <td className="text-end">{item.deductions}</td> <td className="text-end">{item.loan}</td> <td className="text-end"> {item.earnings - (item.deductions + item.loan)} </td> <td> <div style={{ textAlign: "center", color: "green" }} > <FaEye onClick={() => handlePdf(item.emp_id, item.payment_type, item.year, item.confirm_month)} /> </div> </td> <td className="text-center"> <input type="checkbox"
                      onChange={(e) => handleCheckBoxviewapaybill(e, item.emp_id)} checked={selectedCheckboxview.includes(item.emp_id)} />
                    </td> </tr> </>))} </tbody>

                    <tfoot className="table_countshead" > <tr> <td colSpan={4} style={{ textAlign: "right" }}> Total Amount in Rs </td> <td className="text-end"> {MonthlyPaybill?.reduce((a, v) => a + v.earnings, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {MonthlyPaybill?.reduce((a, v) => a + v.deductions, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {MonthlyPaybill?.reduce((a, v) => a + v.loan, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {MonthlyPaybill?.reduce((a, v) => a + (v.earnings - (v.deductions + v.loan)), 0).toLocaleString("en-IN")} </td> <td></td> <td></td> </tr> </tfoot>
                  </OFMSUI.Table>

                  <div style={{ textAlign: "center" }}> <button type="button" className="btn btn-warning btn-sm" style={{ fontSize: "12px" }}
                    onClick={() => { Viewpayslipsofselected(formik.values.payment_type, formik.values.confirm_month, formik.values.year); }}
                  > View paybill </button> </div>


                  <div style={{ textAlign: "center" }}></div>
                  <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" > 
                    <ExportToExcelButton tableId="my-table2" filename="MonthlybillConfirmationReport" sheet="tablexls" buttonText="Excel" /> <button className="btn btn-danger btn-sm"
                    onClick={() => generatePDF("my-table2", "Confirmed List", "MonthlybillConfirmationReport.pdf", 8)}
                    type="button" style={{ float: "right", marginLeft: "5px" }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col> </OFMSUI.Row>

                  <OFMSUI.Table striped bordered hover id="my-table2">
                    <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                      <tr> <td colSpan={10} style={{ textAlign: "center" }}> Confirmed List For {displayemptype}- {displayPaymentType} for the {monthname} {yearName} </td> </tr>
                      <tr className="table_countshead"> <th className="text-center">S No. </th> <th>Employee ID</th> <th>Employee Name</th> <th>Designation</th>  <th className="text-center" >Earnings(in Rs/-)</th> <th className="text-center" >Deductions(in Rs/-)</th> <th className="text-center" >Loan(in Rs/-)</th> <th className="text-center" >Net Salary(in Rs/-)</th>
                        <th classnaem="text-center"> Check All <input type="checkbox" onChange={(e) => checkAllActiongenerate(e)}
                          // checked={checkBoxgenerateAll}
                          checked={checkBoxAllGen}
                        /> </th> </tr>
                    </thead>

                    <tbody>
                      {afterConfirm.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td> <td>{item.emp_id}</td> 
                          {/* <td onClick={() => SaveParams(item.emp_id, item.emp_type, item.payment_type, item.confirm_month, item.year)} > <Link>{item.name}</Link> </td> */}
                          <td onClick={() => SaveParams( item.emp_id, item.emp_type, item.payment_type, item.confirm_month, item.year ) } style={{ cursor: "pointer", color: "blue" }} > {item.name} </td>
                          <td>{item.designation}</td>  <td className="text-end" >{item.earnings}</td> <td className="text-end" >{item.deductions}</td> <td className="text-end" >{item.loan}</td> <td className="text-end" > {item.earnings - (item.deductions + item.loan)} </td>
                          <td> <center><input type="checkbox" onChange={(e) => handleCheckBoxgenerate(e, item.emp_id)} checked={selectedCheckboxGen.includes(item.emp_id)} /> </center>

                          </td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot className="table_countshead" >
                      <tr><td colSpan={4} style={{ textAlign: "right" }}> Total Amount in Rs </td> <td className="text-end"> {afterConfirm?.reduce((a, v) => a + v.earnings, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {afterConfirm?.reduce((a, v) => a + v.deductions, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {afterConfirm?.reduce((a, v) => a + v.loan, 0).toLocaleString("en-IN")} </td> <td className="text-end"> {afterConfirm?.reduce((a, v) => a + (v.earnings - (v.deductions + v.loan)), 0).toLocaleString("en-IN")} </td> <td></td> </tr>

                    </tfoot>
                  </OFMSUI.Table>
                  <div style={{ textAlign: "center" }}> <button type="button" className="btn btn-warning btn-sm" style={{ fontSize: "12px" }}
                    onClick={() => { GeneratedPaybill(formik.values.emp_type, formik.values.payment_type, formik.values.confirm_month, formik.values.year); }} > Generate paybill </button> </div>





                  <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" > <ExportToExcelButton tableId="my-table3" filename="MonthlybillConfirmationReport" sheet="tablexls" buttonText="Excel" /> <button className="btn btn-danger btn-sm"
                    onClick={() => generatePDF("my-table3", "To be Confirmed List", "MonthlybillConfirmationReport.pdf", 8)}
                    type="button" style={{ float: "right", marginLeft: "5px" }} > PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col> </OFMSUI.Row>



                  <OFMSUI.Table striped bordered hover id="my-table3">
                    <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} > <tr> <td colSpan={12} style={{ textAlign: "center" }}> To be Confirmed List For {displayemptype}- {displayPaymentType} for the {monthname} {yearName} </td> </tr>
                      <tr className="table_countshead">
                        <th className="text-center">S No. </th> <th>Employee Id</th> <th>Employee Name</th> <th>Designation</th>  <th className="text-center" >Earnings(in Rs/-)</th> <th className="text-center" >Deductions(in Rs/-)</th> <th className="text-center" >Loan(in Rs/-)</th> <th className="text-center" >Net Salary(in Rs/-)</th>
                        <th classnaem="text-center"> Check All  <input type="checkbox" onChange={(e) => checkAllAction(e)} checked={checkBoxAll} />  </th>
                      </tr>
                    </thead>

                    <tbody>
                      {beforeConfirm.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td> <td>{item.emp_id}</td> <td>{item.name}</td> <td>{item.designation}</td>  <td className="text-end">{item.earnings}</td> <td className="text-end">{item.deductions}</td> <td className="text-end">{item.loan}</td>
                          <td className="text-end"> {item.earnings - (item.deductions + item.loan)} </td> <td style={{ textAlign: "center", color: "green" }}> <input type="checkbox" onChange={(e) => handleCheckBox(e, item.emp_id)} checked={selectedCheckbox.includes(item.emp_id)} /> </td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot className="table_countshead">
                      <tr><td colSpan={4} style={{ textAlign: "right" }}> Total Amount in Rs </td> <td className="text-end" > {beforeConfirm?.reduce((a, v) => a + v.earnings, 0).toLocaleString("en-IN")} </td>
                        <td className="text-end" > {beforeConfirm?.reduce((a, v) => a + v.deductions, 0).toLocaleString("en-IN")} </td> <td className="text-end" >  {beforeConfirm?.reduce((a, v) => a + v.loan, 0).toLocaleString("en-IN")} </td> <td className="text-end" >  {beforeConfirm?.reduce((a, v) => a + (v.earnings - (v.deductions + v.loan)), 0).toLocaleString("en-IN")} </td> <td></td></tr>

                    </tfoot>
                  </OFMSUI.Table>

                  <div style={{ textAlign: "center" }}> <button type="button" className="btn btn-warning btn-sm" style={{ fontSize: "12px" }} onClick={() => { handleConfirm(formik.values.emp_type, formik.values.payment_type, formik.values.confirm_month, formik.values.year); }} > Confirm </button> </div>
                </div>
              </div>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
};

export default MonthlyPaybillConfirmation;
